<template>
    <!--弹窗-->
    <el-dialog v-if="visible" width="900px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <div class="chart-datepicker">
            <div class="range-option" @click="getList(charts_keyword, 30, country_code)"
                 :style="index == 30 ? 'font-weight: bold;color: #508cfd;' : ''">30 天
            </div>
            <div class="range-option" @click="getList(charts_keyword, 90, country_code)"
                 :style="index == 90 ? 'font-weight: bold;color: #508cfd;' : ''">90 天
            </div>
            <div class="range-option" @click="getList(charts_keyword, 365, country_code)"
                 :style="index == 365 ? 'font-weight: bold;color: #508cfd;' : ''">1 年
            </div>
            <div class="range-option" @click="getList(charts_keyword, null, country_code)"
                 :style="index == null ? 'font-weight: bold;color: #508cfd;' : ''">全部
            </div>
        </div>
        <div v-loading="loading" :id="'highcharts-' + charts_id" style="min-height: 400px;"></div>
        <el-divider></el-divider>
        <div class="phrase-stats">
            <div>
                最高搜索量:
                <div class="stat-top-info" v-if="min_num != null">
                    <span>{{ max_num }}</span>
                    <span>( {{ max_date }} )</span>
                </div>
                <span v-else> - </span>

                最低搜索量:
                <div class="stat-top-info" v-if="max_num != null">
                    <span>{{ min_num }}</span>
                    <span>( {{ min_date }} )</span>
                </div>
                <span v-else> - </span>
                平均搜索量:
                <div class="stat-top-info" v-if="ave_search != null">
                    <span>{{ ave_search }}</span>
                </div>
                <span v-else> - </span>

                <div style="float: right;margin-right: 20px;">
                    <div style="width: 50px;height: 10px;background-color: #70a5d6;float: left;margin-top: 9px;margin-right: 10px;"></div>
                    <span style="float:left;">搜索量</span>
                </div>
            </div>
            <div>

                最高份额:
                <div class="stat-top-info" v-if="max_limit != null">
                    <span>{{ max_limit }}</span>
                    <span>( {{ max_limit_date }} )</span>
                </div>
                <span v-else> - </span>

                最低份额:
                <div class="stat-top-info" v-if="min_limit != null">
                    <span>{{ min_limit }}</span>
                    <span>( {{ min_limit_date }} )</span>
                </div>
                <span v-else> - </span>
                平均份额:
                <div class="stat-top-info" v-if="ave_limit != 0">
                    <span>{{ ave_limit }}</span>
                </div>
                <span v-else> - </span>

                <div style="float: right;margin-right: 35px;">
                    <div style="width: 50px;height: 10px;background-color: #000;float: left;margin-top: 9px;margin-right: 10px;"></div>
                    <span style="float:left;">额度</span>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from "@/api/Product/Product";
    import * as Highcharts from "highcharts";
    import * as loadExporting from "highcharts/modules/exporting";
    import * as exportExcel from "highcharts/modules/export-data.src";

    loadExporting(Highcharts);
    exportExcel(Highcharts);
    export default {
        data() {
            return {
                loading: false,
                index: 0,
                max_num: null,
                max_date: null,
                min_num: null,
                min_date: null,
                country_code: null,
                max_limit: null,
                max_limit_date: null,
                min_limit: null,
                min_limit_date: null,
                ave_limit: null,
                ave_search: null,
            };
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ""
            },
            charts_id: {
                type: String,
                default: "0"
            },
            charts_keyword: {
                type: String,
                default: ""
            }
        },
        methods: {
            //最小值
            math_Max_Min(date, rank, limit) {
                let all_search = 0;
                let count_search = 0;
                let max_num = rank[0];
                let max_date = date[0];
                let min_num = rank[0];
                let min_date = date[0];
                for (let i = 1; i < rank.length; i++) {
                    if (rank[i] != null) {
                        count_search++;
                        all_search = all_search + parseInt(rank[i])
                        if (rank[i] > max_num || max_num == null) {
                            max_num = rank[i];
                            max_date = date[i];
                        }
                        if (min_num == null || min_num > rank[i]) {
                            min_num = rank[i];
                            min_date = date[i];
                        }
                    }
                }
                this.max_num = max_num;
                this.max_date = max_date;
                this.min_num = min_num;
                this.min_date = min_date;
                console.log(all_search, count_search);
                this.ave_search = count_search == 0 ? 0 : (all_search / count_search).toFixed(2);


                let ave_limit = 0;
                let count_limit = 0;
                let max_limit = limit[0];
                let max_limit_date = date[0];
                let min_limit = limit[0];
                let min_limit_date = date[0];
                for (let i = 1; i < limit.length; i++) {
                    if (limit[i] != null) {
                        count_limit++;
                        ave_limit = ave_limit + parseFloat(limit[i]);
                        if (limit[i] > max_limit || max_limit == null) {
                            max_limit = limit[i];
                            max_limit_date = date[i];
                        }
                        if (min_limit == null || min_limit > limit[i]) {
                            min_limit = limit[i];
                            min_limit_date = date[i];
                        }
                    }
                }
                this.max_limit = (max_limit * 100).toFixed(2) + '%';
                this.max_limit_date = max_limit_date;
                this.min_limit = (min_limit * 100).toFixed(2) + '%';
                this.min_limit_date = min_limit_date;
                this.ave_limit = count_limit == 0 ? 0 : (ave_limit / count_limit * 100).toFixed(2) + '%';
            },
            getList(keyword, index, country_code) {
                if (index !== null) {
                    if (this.index == index) return;
                }
                if (country_code) {
                    this.country_code = country_code;
                }
                this.index = index;
                this.loading = true;
                api.sb_search_trend({
                    keywords: [keyword],
                    days: index,
                    country_code: country_code
                })
                    .then(res => {
                        this.loading = false;
                        if (res.code === 0) {
                            let res_date = res.data[keyword].date;
                            this.math_Max_Min(
                                res_date,
                                res.data[keyword].show_num_sum,
                                res.data[keyword].keyword_show_share_num,
                            );
                            this.getCharts(
                                res_date,
                                res.data[keyword].show_num_sum,
                                res.data[keyword].keyword_show_share_num,
                            );
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            getCharts(date, data, data2) {
                Highcharts.chart("highcharts-" + this.charts_id, {
                    chart: {
                        type: "line"
                    },
                    title: {
                        text: null
                    },
                    yAxis: [
                        {
                            allowDecimals: false,
                            reversed: false,
                            min: 1,
                            labels: {
                                style: {color: 'rgb(112, 165, 214)'},
                            },
                            title: {
                                style: {color: 'rgb(112, 165, 214)'},
                                text: "搜索量"
                            }
                        },
                        {
                            type: 'spline',
                            allowDecimals: false,
                            reversed: false,
                            min: 0,
                            max: 100,
                            title: {
                                text: "额度(%)"
                            },
                            labels: {
                                format: '{value}%'
                            },
                            opposite: true
                        },
                    ],
                    xAxis: [
                        {
                            categories: date,
                            title: {
                                text: "DateTime"
                            },
                            tickInterval: Math.ceil(date.length / 6),
                            tickWidth: 1
                        }
                    ],
                    tooltip: {
                        crosshairs: [
                            {
                                width: 1,
                                color: "#ddd"
                            }
                        ],
                        shared: true, //公用一个提示框
                        formatter: function () {
                            var s =
                                "<div style='font-weight: 900;'>" +
                                this.x +
                                "</div>";
                            s += "<br/><br/><b>" + "搜索量: " + this.points[0].y;
                            s += "<br/><br/><b>" + "额度: " + this.points[1].y + '%';
                            return s;
                        }
                        // pointFormat: `<br/><div style="color: rgb(134, 178, 234) !important;">你的产品</div><br/>排名: <b>{point.y}</b><br/><br/>`
                    },
                    plotOptions: {
                        series: {
                            cursor: "pointer",
                            label: {
                                connectorAllowed: false
                            },
                            events: {
                                click: function (event) {
                                    // console.log(event.point.options);
                                    console.log(event.point);
                                }
                            }
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {enabled: false},
                    series: [
                        {
                            data: data,
                            name: "搜索量",
                            yAxis: 0,
                        },
                        {
                            data: (function () {
                                var arr = [];
                                var time = (new Date()).getTime();
                                for (var i = 0; i < data2.length; i++) {
                                    if (data2[i] == null) {
                                        arr.push(data2[i]);
                                    } else {
                                        arr.push(Math.floor(data2[i] * 10000) / 100);
                                    }
                                }
                                return arr;
                            }()),
                            tooltip: {
                                valueSuffix: ' %'
                            },
                            name: "额度",
                            yAxis: 1,
                        },
                    ],
                    responsive: {
                        rules: [
                            {
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: "horizontal",
                                        align: "center",
                                        verticalAlign: "bottom"
                                    }
                                }
                            }
                        ]
                    },
                    exporting: {
                        filename: `${this.title} (数据统计图)`,
                        menuItemDefinitions: {
                            printChart: {
                                text: "打印图表"
                            },
                            downloadJPEG: {
                                text: "下载JPEG 图片"
                            },
                            downloadPDF: {
                                text: "下载PDF 文档"
                            },
                            downloadPNG: {
                                text: "下载PNG 图片"
                            },
                            downloadSVG: {
                                text: "下载SVG 矢量图"
                            },
                            exportButtonTitle: {
                                text: "导出图片"
                            },
                            downloadCSV: {
                                text: "下载CSV 数据表"
                            },
                            downloadXLS: {
                                text: "下载XLS 数据表"
                            }
                        },
                        buttons: {
                            contextButton: {
                                menuItems: [
                                    "printChart",
                                    "separator",
                                    "downloadJPEG",
                                    "downloadPDF",
                                    "downloadPNG",
                                    "downloadSVG",
                                    "separator",
                                    "downloadCSV",
                                    "downloadXLS"
                                ]
                            }
                        }
                    }
                });
            },
            // 关闭弹窗
            handleClose() {
                this.$emit("close-callback", true);
            }
        }
    };
</script>
<style type="text/scss" lang="scss" scoped>
    .chart-datepicker {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        margin-bottom: 20px;
    }

    .range-option {
        font-size: 13px;
        color: #3a3a3a;
        padding: 0 10px;
        text-decoration: underline;
        cursor: pointer;
    }

    .range-option:hover {
        color: #666;
        text-decoration: none;
    }

    .phrase-stats {
        margin-left: 10px;
        margin-bottom: 10px;

        div {
            line-height: 30px;
            font-weight: 700;
            font-size: 16px;
        }

        span {
            margin-right: 5px;
        }
    }

    .stat-top-info {
        display: inline-block;
    }

    /deep/ .el-dialog__body {
        padding: 10px 20px 20px 20px !important;
    }
</style>
